import getEndpointNameForMode from './utils/getEndpointNameForMode';
import PersistedAddinCommand from './schema/PersistedAddinCommand';
import persistedAddins from './persistedAddins';
import { ExtensibilityModeEnum } from 'owa-addins-types';

export default function getPersistedAddin(mode: ExtensibilityModeEnum): PersistedAddinCommand {
    const modeString = getEndpointNameForMode(mode);
    return persistedAddins()[modeString];
}
